import React, { useState, useEffect } from 'react';
import ActionsCardView from '../view/ActionsCardView';

const ActionsCardEngine = ({
  id,
  title = '',
  children,
  actionButtons,
  buttonsAlwaysVisible = false,
  onDelete,
  useDeleteDialog = true,
  isActive = true,
  disabled = false,
  neverDisableActionButtons,
  onDisabledClicked,
  onDeleteSequenceStart = () => {},
  deleteDialogProps = {},
  isInAnimatedConrainer,
  collapse = false,
  collapseSummary = null,
  expandViaArrow = false,
  initAsExpanded = false
}) => {
  const [isHovered, setIsHoverd] = useState(false);
  const [isInDeleteSequence, setIsInDeleteSequence] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const [expanded, setExpanded] = useState(initAsExpanded);

  useEffect(() => {
    isInDeleteSequence && onDeleteSequenceStart();
  }, [isInDeleteSequence]);

  const viewProps = {
    id,
    title,
    buttonsAlwaysVisible,
    children,
    useDeleteDialog,
    isDeleteDialogOpen,
    setIsDeleteDialogOpen,
    isInDeleteSequence,
    setIsInDeleteSequence,
    actionButtons,
    onDelete,
    isActive,
    disabled,
    neverDisableActionButtons,
    onDisabledClicked,
    isHovered,
    setIsHoverd,
    deleteDialogProps,
    isInAnimatedConrainer,
    collapse,
    collapseSummary,
    expanded,
    setExpanded,
    expandViaArrow
  };
  return <ActionsCardView {...viewProps} />;
};

export default ActionsCardEngine;
